var DIMENSIONS = {
    SIDE_BAR_WIDTH: 430,
    STORE_SIDE_BAR_WIDTH: 560,
    MOBILE_PADDING: 120,
    NO_PADDING: 0,
};
export default DIMENSIONS;
//# sourceMappingURL=dimensions.js.map